document.addEventListener('DOMContentLoaded', () => {
  const tooltips = document.querySelectorAll('.tooltip');

  tooltips.forEach((tooltip) => {
    tooltip.addEventListener('click', (e) => {
      if (window.matchMedia('(hover: none)').matches) {
        e.stopPropagation();
        const isActive = tooltip.classList.contains('tooltip-active');
        document.querySelectorAll('.tooltip.tooltip-active')
          .forEach((t) => t.classList.remove('tooltip-active'));

        if (!isActive) {
          tooltip.classList.add('tooltip-active');
        }
      }
    });
  });

  document.addEventListener('click', () => {
    document.querySelectorAll('.tooltip.tooltip-active')
      .forEach((t) => t.classList.remove('tooltip-active'));
  });
});
